<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <!-- لودینگ ذخیره خودکار -->
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
        <div class="text-center d-flex flex-column align-center justify-center">
          <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
          <h3 class="mt-4 green--text">در حال ذخیره‌سازی خودکار...</h3>
          <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
        </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <!-- تب‌های بالا سمت چپ -->
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true">
              {{ $t("show_qr") }}
            </v-tab>
            <v-tab :ripple="true"> {{ $t("preview") }}</v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <!-- پیش‌نمایش تب‌ها -->
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" />
            </v-tab-item>

            <v-tab-item>
              <view-bank-card :value="bankCard" :qr-svg-data-url="qrSvgDataUrl"/>
            </v-tab-item>

            <v-tab-item v-if="!!info?.id && e6 > 1">
              <Tariffs :id_qr="info.id" :qrtype="'bankcard'" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <!-- استپ‌های فرم -->
        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-row class="pa-2" justify="start" style="width: 100%">
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              
              <!-- استپ ۱: ثبت نام و آدرس کیوآر -->
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <v-row no-gutters>
                  <v-col class="pa-2" cols="12">
                    <p class="font-weight-bold">وارد کردن اطلاعات کیوار کیوکارت</p>
                  </v-col>

                  <v-col class="pa-2 d-flex row rowinfo" cols="12" md="6">
                    <v-text-field
                      v-model="bankCard.visitName"
                      :disabled="e6 > 1"
                      :error-messages="errors['title']"
                      append-icon="mdi-credit-card-outline"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام کیوار کیوکارت"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام کیوار کیوکارت"
                    />
                  </v-col>

                  <v-col class="pa-2 rowinfo" cols="12" md="6">
                    <qr-address-field
                      id="qr-address"
                      ref="address-field"
                      v-model="dtUrl"
                      :disabled="e6 > 1"
                      :error-messages="errors['identifier']"
                      append-icon="mdi-web"
                      class="ma-0 pa-0 contentinfo"
                      width="88%"
                      dense
                      outlined
                      persistent-hint
                      @updateDest="domainId = $event"
                      :key="$t('qrAddressUpdate.hints.allowedChars')"
                      :hint="$t('qrAddressUpdate.hints.allowedChars')"
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-dtUrl`"
                      :label="$t('qr_address')"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                    />
                  </v-col>
                </v-row>
              </v-stepper-step>

              <v-stepper-content step="1">
                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="markQr"
                  />
                </div>
              </v-stepper-content>

              <!-- استپ ۲: آیتم‌ها (۳ بخش درخواستی) -->
              <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
                {{ $t("info") }}
              </v-stepper-step>
              
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                <!-- سوییچ و راهنمای ذخیره خودکار -->
                <div class="mb-4 mx-4">
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود.
                      </span>
                    </v-tooltip>
                  </div>

                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود.
                  </div>
                </div>

                <!-- لیست بازشونده ۳ بخش (اطلاعات کاربر، مدیریت حساب‌ها، مدیریت رنگ) -->
                <list-expansion
                  v-model="bankCard"
                  :components="specialInfo"
                  :data="bankCard"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"
                />

                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>

            <div class="d-none">
              <qr-code-make
                ref="qrCanvas"
                v-model="qrDesign"
                :file.sync="qrSvgDataUrl"
                :link="fullLink"
                @save="qrDesign = $event"
              />
            </div>
          </v-row>
        </v-col>
        <QrIntroModal
      storageKey="BankCardIntroSeen"
      title="کیوآر کیوکارت"
      :pro="false"
      icon="mdi-credit-card-outline"
      iconColor="blue darken-2"
      :description="introText"
    />

      </v-row>
    
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapActions } from "vuex";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import { getLanguageCookie } from "@/core/plugins/TitleRibbon/utils/languageCookie";
import viewBankCard from "./viewBankCard.vue";
import Tariffs from "../../components/Tariffs/Tariffs.vue";
import { AtomSpinner } from "epic-spinners";
import QrIntroModal from "../QrIntroModal.vue";

export default {
  name: "BankCard",

  components: {
    viewBankCard,
    QrCodeMake,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrMaker,
    Tariffs,
    AtomSpinner,
    QrIntroModal
    
  },

    data() {
    return {
            introText: `
  <strong>کیوکارت</strong> یک راهکار حرفه‌ای و هوشمند برای مدیریت و اشتراک‌گذاری تمامی حساب‌های مالی شما در یک صفحه واحد است. با این ابزار، به جای ارسال پراکنده شماره کارت یا شبا، یک ویترین دیجیتال زیبا و کارآمد از اطلاعات حساب‌های خود داشته باشید.
  <br><br>
  <strong>قابلیت‌های کلیدی:</strong>
  <br>
  <span style="padding-right: 15px; display: block;">
    <strong>۱. تجمیع و مدیریت یکپارچه:</strong> ثبت و مدیریت آسان تمامی کارت‌های بانکی، شماره‌حساب‌ها و شماره‌های شبا در یک فضای امن و مرتب.<br>
    <strong>۲. انتقال سریع و بدون خطا:</strong> اشتراک‌گذاری اطلاعات با مخاطبین، مشتریان یا همکاران از طریق دکمه‌های کپی سریع (Copy to Clipboard)؛ بدون نگرانی از خطاهای تایپی.<br>
    <strong>۳. شخصی‌سازی و برندینگ:</strong> امکان تنظیم رنگ‌بندی صفحه، افزودن لوگوی اختصاصی و تغییر تم مطابق با سلیقه یا هویت بصری کسب‌وکار شما.
  </span>
  <br>
  این کیوآر بهترین ابزار برای فریلنسرها، فروشگاه‌های آنلاین و هر شخصی است که می‌خواهد فرآیند دریافت وجه را سریع، مدرن و حرفه‌ای انجام دهد.
`,

      isAutoSaving: false,
      AutoSave: false,
      loading: false,
      bankCard: {
        language: "fa",
        langs: {
          source_lang: "fa",
          other_langs: [],
        },
        infoUser: {
          nameCollection: "ترمینال تبلیغات",
          subTitle: "اطلاعات حساب‌های بانکی جهت واریز وجه",
          logoImage: "/media/defaults/qrLogo.webp",
          background: "https://cdn.terminalads.com/upload/9be5a015e903852f5c0e1645e905f73e.webp",
        },
        cardBank: {
  displayType: "slider",
  sizeLevel: 2,
  cardTheme: "white",
        list: [
          // --- بانک ملی ایران ---
          {
            id: 1011,
            description: "طرح ۱ - ملی کرم سنتی",
            bank_name: "بانک ملی",
            account_number: "0101234567890",
            cart_number: "6037997123456789",
            shaba_number: "017010000000101234567890",
            owner_name: "محمد فلاح",
            bank_logo: "/img/Melli.svg",
            bank_color: null
          },

          // --- بانک ملت ---
          {
            id: 1009,
            description: "طرح ۱ - ملت قرمز کلاسیک",
            bank_name: "بانک ملت",
            account_number: "45678901234",
            cart_number: "6104337890123456",
            shaba_number: "012010000000045678901234",
            owner_name: "محمد فلاح",
            bank_logo: "/img/Mellat.svg",
            bank_color: null
          },

          // --- بانک پاسارگاد ---
          {
            id: 1037,
            description: "پاسارگاد طلایی مشکی",
            bank_name: "بانک پاسارگاد",
            account_number: "2011234567",
            cart_number: "5022291012345678",
            shaba_number: "057010000000002011234567",
            owner_name: "محمد فلاح",
            bank_logo: "/img/Pasargad.svg",
            bank_color: null
          },

          // --- مؤسسه اعتباری ملل ---
          {
            id: 1050,
            description: "مؤسسه اعتباری ملل طلایی",
            bank_name: "موسسه اعتباری ملل",
            account_number: "6041234567",
            cart_number: "6062561012345678",
            shaba_number: "075010000000006041234567",
            owner_name: "محمد فلاح",
            bank_logo: "/img/Melal.svg",
            bank_color: null
          },

          // --- بانک مسکن ---
          {
            id: 1020,
            description: "طرح ۱ - مسکن نارنجی خطی",
            bank_name: "بانک مسکن",
            account_number: "41012345678",
            cart_number: "6280231312345678",
            shaba_number: "014010000000004101234567",
            owner_name: "محمد فلاح",
            bank_logo: "/img/Maskan.svg",
            bank_color: null
          },

          // --- بانک تجارت ---
          {
            id: 1018,
            description: "طرح ۱ - تجارت برج آزادی",
            bank_name: "بانک تجارت",
            account_number: "1001234567",
            cart_number: "5859831012345678",
            shaba_number: "018010000000001001234567",
            owner_name: "محمد فلاح",
            bank_logo: "/img/Tejarat.svg",
            bank_color: null
          },

          // --- بانک گردشگری ---
          {
            id: 1027,
            description: "طرح ۱ - طبیعت گردشگری",
            bank_name: "بانک گردشگری",
            account_number: "1101234567",
            cart_number: "5054161012345678",
            shaba_number: "064010000000001101234567",
            owner_name: "محمد فلاح",
            bank_logo: "/img/Gardeshgari.svg",
            bank_color: null
          }
        ]
        },
        theme: "",
        visitName: "کارت بانکی",
        pallete: {
          bodyColor: "linear-gradient(to top right , #020040A7, #BBDAFFFF)",
          textColor: "#FFFAE9FF",
          buttonColor: "linear-gradient(to top right , #020040A7, #BBDAFFFF)",
        },
        apiKey: "GAPGPTMASKTOKENw1fsy8qdizgX0X",
      },
      helpData: [],
      componentName: "bankcard",
      serviceName: "Qrland",
      qrDesign: {},
      e6: 1,
      errors: {},
      createdId: null,
      createdDomain: null,
      dtUrl: null,
      domainId: null,
      qrShow: 1,
      qrSvgDataUrl: "",
      info: {},
    };
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.bankCard.visitName = "کیوکارت";
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },

  computed: {
    specialInfo() {
      return [
        {
          name: "AddAccount",
          value: "",
          title: "افزودن اطلاعات کاربر",
          subtitle: "",
          icon: "account-outline",
          model: "infoUser",
        },
        {
          name: "ManagementAccountBank",
          value: "",
          title: "مدیریت حساب ها",
          subtitle: "",
          model: "cardBank",
          icon: "credit-card-outline",
        },
        {
          name: "ManagementColor",
          value: "",
          title: "مدیریت رنگ",
          icon: "palette",
          model: "pallete",
        },
      ];
    },

    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),

    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error(this.$t("invalid_qr_address"));
        return;
      }

      this.loading = true;
      this.bankCard.language = getLanguageCookie() || "fa";
      this.bankCard.langs = {
        source_lang: this.bankCard.language,
        other_langs: [],
      };

      const obj = {
        type: "bankcard",
        qrType: "dynamic",
        title: this.bankCard.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          data: this.bankCard,
        }),
        qr: JSON.stringify(this.qrDesign),
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.createdId = data.data.identifier;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId
          ).name;
          this.info = data.data;
          this.setCreatedQrID(data.data.id);
          this.$toast.success("کیوآر کیوکارت شما با موفقیت ساخته شد.");

          if (this.e6 === 1) {
            this.e6 = 2;
            this.qrShow = 0;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
                this.qrShow = 1;
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response?.status === 422) {
            this.$modal.error("خطا", response.data.message);
          }

          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};
          if (response?.data?.errors) {
            const backendErrors = response.data.errors;
            Object.entries(backendErrors).forEach(([fieldKey, fieldMessages]) => {
              try {
                translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                  const key = errorMap[msg];
                  return key ? this.$t(key) : msg;
                });
                const msg = fieldMessages[0];
                const key = errorMap[msg];
                this.$toast.error(key ? this.$t(key) : msg, { timeout: 3000 });
              } catch (e) {
                console.log("Error in mapping translation: ", e);
              }
            });
            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          const el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }

      const data = new FormData();
      data.append("type", "bankcard");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append("qr_id", this.info.qrId);
      this.bankCard.language = getLanguageCookie() || "fa";

      data.append(
        "data",
        JSON.stringify({
          data: this.bankCard,
        })
      );

      const finalData = {
        data: this.bankCard,
      };

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(({ data }) => {
          if (final) {
            this.info = data.data;
            const allLangs = [
              this.bankCard.language,
              ...(this.bankCard.langs?.other_langs || []).map((l) => l.lang),
            ];

            if (allLangs.length > 0) {
              this.$api
                .post(`/v1/testQr/update-lang-data/${data.data.id}`, {
                  data: finalData,
                  langs: allLangs,
                })
                .then(() => {})
                .catch(() => {})
                .finally(() => {
                  this.loading = false;
                  this.$toast.success("کیوآر کیوکارت با موفقیت ویرایش شد.");
                });
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          if (final) {
            this.goto("qr/list");
            this.qrShow = 0;
          }
          this.loading = false;
          this.isAutoSaving = false;
        });
    },

    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      this.bankCard.visitName = "کیوکارت";
      this.bankCard.apiKey = "GAPGPTMASKTOKENw1fsy8qdizgX1X";
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}

.help-info-wrapper {
  display: inline-block;
  vertical-align: middle;
  margin-left: 1px;
}

qr-address-field {
  width: 88% !important;
}

.warp {
  position: relative;
  overflow: visible !important;
  min-height: 50px;
}

.doublebtn {
  gap: 8px;
}
</style>
